// 定义项目内的表名
const tableApproval = 'tableApproval'
const supplierList = 'supplierList'
const tmplDemo1 = 'approval/supplier/supplier-list-tableDemo1'
const tmplDemo2 = 'approval/supplier/supplier-list-tableDemo2'
const tmplDemo3 = 'approval/supplier/supplier-list-tableDemo3'

const tableList = {
  tableApproval,
  supplierList,
  tmplDemo1,
  tmplDemo2,
  tmplDemo3
}

export default tableList
